import React, { useContext, useEffect } from 'react';
import { Typography, Grid, Divider, Box, useMediaQuery, useTheme } from '@material-ui/core';
import { Container } from './../Container/Container';
import { ChangeLocaleButton } from '../ChangeLocaleButton/ChangeLocaleButton';
import { CardLink } from './Components/CardLink/CardLink';
import lagportalenImg from '../../Assets/Images/lagportalen.png';
import organisationImg from '../../Assets/Images/organisation.png';
import verksamhetsutvecklingImg from '../../Assets/Images/verksomhetsutveckling.png';
import { FormattedMessage } from 'react-intl';
import {
  UserContext,
  Module,
  AccessLevel,
  LawPortalFeature,
  AdminFeature,
} from '../../Context/UserContext/UserContext';
import { NotAuthorized } from './NotAuthorized';
import { ServerError } from './ServerError';
import logo from '../../Assets/Images/aptor_logo.svg';
import { ImpersonationForm } from './Components/ImpersonationForm/ImpersonationForm';
import { LogoutButton } from './Components/LogoutButton/LogoutButton';
import { Logo } from '../Logo/Logo';
import { useStyles } from './Home.styles';
import { Forbidden } from './Forbidden';
import { getAppConfiguration } from '../../Config';
import { EnterName } from './EnterName';
import { useNavigate } from 'react-router-dom';

interface HomeProps {
  forbidden?: boolean;
  notAuthorized?: boolean;
  serverError?: boolean;
}

const Home: React.FC<HomeProps> = ({ forbidden, notAuthorized, serverError }) => {
  const classes = useStyles();
  const { firstName, hasAccessToModule, hasAccessToFeature, lastName, applicationVersion } = useContext(UserContext);
  const { enableImpersonation } = getAppConfiguration();
  const isOldVersion = applicationVersion?.value === 1;
  const navigate = useNavigate();
    const isMobile = useMediaQuery('(max-width: 1098px)');
  const isDesktop = useMediaQuery('(min-width: 1099px)');
  useEffect(() => {
    if (
      hasAccessToModule(Module.LawPortal) &&
      !hasAccessToModule(Module.Administration) &&
      !(
        hasAccessToModule(Module.Organization) ||
        hasAccessToFeature(LawPortalFeature.Manage, AccessLevel.Read)
      )
    ) {
      navigate('/law-portal/dashboard');
    }
  }, [hasAccessToModule, hasAccessToFeature, navigate]);

  return (
    <div>
      {/* Desktop */}
      {isDesktop&&<Grid
          className={classes.topMenu}
          container
          justifyContent="space-between"
          alignItems="center"
        >
          <Grid item>
            <Logo src={logo} alt="Aptor logo" disablePadding />
          </Grid>
          {/* {enableImpersonation && isOldVersion &&
            hasAccessToFeature(AdminFeature.Administrate, AccessLevel.Read) && (
              <Grid item sm={6}>
                <ImpersonationForm />
              </Grid>
            )} */}

          <Grid item>
            <ChangeLocaleButton />
            <LogoutButton />
          </Grid>
        </Grid>}
      {/* Tablet & Mobile */}
      {isMobile&&
      <Box>
        <Grid
          className={classes.topMenuMobile}
          container
          justifyContent="space-between"
          alignItems="center"
        >
          <Grid item>
            <Logo src={logo} alt="Aptor logo" disablePadding small />
          </Grid>
          <Grid item>
            <ChangeLocaleButton />
            <LogoutButton />
          </Grid>
        </Grid>
        <Divider />
        {/* {enableImpersonation && isOldVersion &&
          hasAccessToFeature(AdminFeature.Administrate, AccessLevel.Read) && (
            <ImpersonationForm />
          )} */}
      </Box>
      }
      <Container>
        {(forbidden && <Forbidden />) ||
          (notAuthorized && <NotAuthorized />) ||
          (serverError && <ServerError />) ||
          ((!firstName || !lastName) && <EnterName />) || (
            <>
              <Typography
                className={classes.heading}
                variant="h1"
                align="center"
                color="primary"
                gutterBottom
              >
                <FormattedMessage
                  id="component.home.welcome"
                  defaultMessage="Start page"
                  description="Welcome message"
                />
                {` ${firstName}!`}
              </Typography>
              <Typography className={classes.subHeading} variant="h2" align="center">
                <FormattedMessage
                  id="component.home.chooseModule"
                  defaultMessage="Choose module"
                  description="Choose module message"
                />
              </Typography>

              <Grid container spacing={2} justifyContent="center">
                {hasAccessToModule(Module.Administration) && (
                  <CardLink
                    link="/admin"
                    label="component.home.aptor-admin"
                    image={verksamhetsutvecklingImg}
                  />
                )}
                {hasAccessToModule(Module.LawPortal) && (
                  <CardLink
                    link="/law-portal"
                    label="component.home.law-portal"
                    image={lagportalenImg}
                  />
                )}
              </Grid>
            </>
          )}
      </Container>
    </div>
  );
};

export default Home;